import { Box } from '@mui/material';
import { useMemo, useState } from 'react';

import { POST_VACCINATION_REACTIONS_PETS_CSV } from '../../data/post-vaccination-reactions-pets';
import { parseReactionsCSV } from '../../lib/parse-reactions';
import { ReactionsFilters } from '../reactions-filters';
import { ReactionsTable } from '../reactions-table';

export const PostVaccinationReactionsPetsTab = () => {
  const [filter, setFilter] = useState('');

  const allReactions = useMemo(() => {
    return parseReactionsCSV(POST_VACCINATION_REACTIONS_PETS_CSV);
  }, []);

  const filteredReactions = useMemo(() => {
    if (!filter) return allReactions;

    const lowerFilter = filter.toLowerCase();
    return allReactions.filter(
      (reaction) =>
        reaction.code.toLowerCase().includes(lowerFilter) ||
        reaction.ru.toLowerCase().includes(lowerFilter) ||
        reaction.en.toLowerCase().includes(lowerFilter),
    );
  }, [allReactions, filter]);

  return (
    <Box display="flex" flexDirection="column">
      <ReactionsFilters
        title="Post-vaccination reactions (Pets)"
        filter={filter}
        totalCount={filteredReactions.length}
        onFilterChange={setFilter}
      />
      <ReactionsTable reactions={filteredReactions} />
    </Box>
  );
};
